<template>
  <div id="kepu">
    <div style="margin: 10px;">
        <Button type="primary" @click="modal = true">上传防御科普</Button>
    </div>
    <Modal v-model="modal" okText='提交' @on-ok="ok" class-name="kepuModel">
       
            <Upload
                :action="action"
                :before-upload="upload"
            >
                <Button icon="ios-cloud-upload-outline" style="width:100%"
                    >点击上传文件</Button
                >
            </Upload>
            显示名称：<Input v-model="fileName" placeholder="输入防御科普文章名称" style="width: 300px" />
    </Modal>
    <List class="kepu">
      <ListItem v-for="item in productList" :key="item.id">
        <ListItemMeta :title="item.title" />
        <template slot="action">
          <li>
            <Button type="primary" @click="checkPDF(item.fyurl)">查看</Button>
          </li>
          <li>
            <Button type="error" @click="deleteProduct(item.id, item.title)">删除</Button>
          </li>
        </template>
      </ListItem>
    </List>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data() {
    return {
      Mondata: [],
      tableData: [],
      productList: [],
      layer: null,
      modal: false,
      //上传数据文件
      file: null,
      fileName: '',
      //
      action: "https://www.baidu.com",
    };
  },
  mounted() {
      let t = this;
      layui.use('layer', function(){
          t.layer = layer;
      })
      $.get(this.$ipConfig.getTypthoonDefence).then(data => {
        if (data.message === "查询成功") {
          t.productList = data.dataList;
        } else {
          t.$Message.error({
            content: data.message,
            duration: 5
          });
        }
      });
  },
  destroyed() {
  },
  methods: {
    checkPDF(url) {
        //iframe层
        this.layer.open({
            type: 2,
            title: '防御科普',
            shadeClose: true,
            shade: 0.8,
            area: ['70%', '80%'],
            content: 'https://www.moodsmap.com/files/tfkp.pdf' //iframe的url
        });
    },
    deleteProduct(id, title){
        //询问框
        let t = this;
        this.layer.confirm('是否删除' + title + '?', {
            btn: ['确认','取消'] //按钮
        }, function(){
            $.get(this.$ipConfig.deleteByDefense + '&thisid=' + id).then(data => {
                if (data.message === "查询成功") {
                    t.layer.msg('删除成功', {icon: 1});
                } else {
                    t.layer.msg('删除失败', {icon: 2});
                }
            });
            
        }, function(){
            
        });
    },
    //上传文件
    upload(file) {
      this.file = file;
      this.fileName = file.name.split('.')[0];
      return false;
    },
    ok(){
      let t = this;
      let fd = new FormData();
    //   fd.append("para", {name: t.fileName});
      if (t.file == null) {
        t.$Message.error("请选择数据文件!");
        return;
      }
      fd.append("file", t.file);
      $.ajax({
        url: t.$ipConfig.attachment,
        type: "POST",
        contentType: false,
        mimeType: "multipart/form-data",
        processData: false,
        data: fd,
        cache: false,
        success: function(data) {
            
        },
        error: function(error) {
          if (error) {
            t.$Message.error(error.statusText);
          } else {
            t.$Message.error("内部错误");
          }
        }
      });
    }
  }
};
</script>

<style scope>
#kepu {
  width: 100%;
  height: calc(100% - 10px);
  text-align: left;
}
#kepu .kepu {
  margin-left: 20px;
}

</style>



// WEBPACK FOOTER //
// src/common/kepu.vue